import _ from 'underscore';
import Handlebars from 'handlebars';
import i18n from 'l10n';
import callingcode from 'callingcodewithdefaultcountry';
import moment from 'moment-timezone';
import md5 from 'md5';
import Optional from 'optional-js';
import Maybe from 'js/traits/maybe.type.js';
import {equals, includedIn} from "../utils/predicates";

require('pnglib');
require('identicon');
require('unorm');
require('js/adapters/handlebars-partials');
require('dynamicFontSize');


const toBlockHelper = predicate => _.wrap(predicate, function (...args) {
    const p = args.shift();
    if (!_.isFunction(p))
        throw Error("handlebars-helpers::booleanToBlockHelper -> given predicate wasn't a function");
    const predicateArgs = _.initial(args);
    const options = _.last(args);
    return p(...predicateArgs) ? options.fn(this) : options.inverse(this);
});

/**
 * This function computes crc value
 *
 * @return {number}
 */
const FindCRC = function (data, datalen) {
    let i, j;
    let c;
    let CRC = 0;
    const genPoly = 0x07;
    for (j = 0; j < datalen; j++) {
        c = data.charCodeAt(j);
        CRC ^= c;
        for (i = 0; i < 8; i++)
            if (CRC & 0x80)
                CRC = (CRC << 1) ^ genPoly;
            else
                CRC <<= 1;
        CRC &= 0xff;
    }
    return CRC;
};

const tellodyLightClasses = [
    "boldPeach",
    "zanteBlue",
    "marineGreen",
    "barbieMauve",
    "mickeyPink",
    "ripeSquash",
    "timidFuchsia",
    "priceyEmerald",
    "freshCabbage",
    "lightBrick"
];

Handlebars.registerHelper("embedCode", (subDomain, campaignId) =>
    `<iframe id="optin-embed" width="500" height="700" frameBorder="0" src="https://${subDomain}.tellody.com/o/${campaignId}?embed=true"></iframe>`);

Handlebars.registerHelper("inc", function (value) {
    return parseInt(value) + 1;
});

Handlebars.registerHelper("hasProperty", function (obj, prop) {
    return obj && obj.hasOwnProperty(prop);
});

Handlebars.registerHelper("stateColorClass", function (value) {
    const map = {
        Bought: "fg-emerald",
        Reacted: "fg-orange",
        Pending: "fg-orange",
        Failure: "fg-red"
    };
    return map[value];
});

const jsInjectionCleaner = function (rawString) {
    rawString = rawString ? rawString.replace(/</g, "&lt;").replace(/>/g, "&gt;")
        .replace(/[ ]*(on|ON)[a-zA-Z]+\=(\'|\").+(\"|\') /g, "") : "";
    return $("<span/>").text(rawString).text();
};

Handlebars.registerHelper('injectionCleaner', jsInjectionCleaner);

Handlebars.registerHelper('tilecolorclass', function (id) {
    if (!id) {
        return tellodyLightClasses[Math.floor((Math.random() * tellodyLightClasses.length))];
    }
    if (id.length === undefined) {
        id = `${id}`;
    }
    const crc = FindCRC(id, id.length);
    const i = crc % tellodyLightClasses.length;
    const bgclass = tellodyLightClasses[i];
    return new Handlebars.SafeString(bgclass);
});

Handlebars.registerHelper('contactStatus', function (status) {
    if (status === 1) {
        return new Handlebars.SafeString("<i class='place-right fg-darkRed icon-record'></i>");
    } else {
        return new Handlebars.SafeString("");
    }

});

Handlebars.registerHelper('contactEmailBouncedStatus', function (isBounced) {
    if (isBounced === 1) {
        return new Handlebars.SafeString("<i class='place-right fg-darkBlue fak fa-snowflake-o'></i>");
    } else {
        return new Handlebars.SafeString("");
    }
});

Handlebars.registerHelper('contactSmsBouncedStatus', function (isBounced) {
    if (isBounced === 1) {
        return new Handlebars.SafeString("<i class='fg-mauve icon-locked'></i>");
    } else {
        return new Handlebars.SafeString("");
    }
});

Handlebars.registerHelper('optinUrl', function (userId, campaignId, prefix) {
    return `https://${typeof prefix === "string" ? prefix : ''}${userId}.tellody.com/o/${campaignId}`;
});

Handlebars.registerHelper('urlEncode', function (url) {
    return new Handlebars.SafeString(encodeURIComponent(url));
});

Handlebars.registerHelper('timestamp', function (timestamp, format) {
    if (timestamp === undefined) {
        return "";
    } else if (timestamp === null) {
        return i18n.t("now");
    } else {
        const realTimestamp = timestamp.hasOwnProperty("millis") ? timestamp.millis : timestamp;
        const date = new Date(realTimestamp);
        if (format === undefined || format.hash) {
            format = i18n.t("$datetimeformat");
        }
        return new Handlebars.SafeString(toDate(date, {format: format}));
    }
});

Handlebars.registerHelper('timestampForCustomField', function (timestamp, format) {
    if (timestamp == null) {
        return null;
    } else {
        const date = new Date(timestamp);
        if (format === undefined || format.hash) {
            format = i18n.t("$datetimeformat");
        }
        return new Handlebars.SafeString(toDate(date, {format: format}));
    }
});

Handlebars.registerHelper('reltimestamp', function (timestamp) {
    if (timestamp === undefined) {
        return "";
    } else {
        const date = new Date(timestamp);
        return new Handlebars.SafeString(toDate(date, {relative: true}));
    }
});

// Handlebars.registerHelper('getBrowser', $.get_browser);

Handlebars.registerHelper('supportsCopyToClipboard', toBlockHelper(function () {

    const isCompatible = ({name, version}, vendor, targetVersion) =>
        name === vendor && version === targetVersion;

    var browser = $.get_browser();
    var chrome = isCompatible(browser, "Chrome", 43);
    var ie = isCompatible(browser, "IE", 9);
    var opera = isCompatible(browser, "Opera", 29);
    var safari = isCompatible(browser, "Safari", 10);
    var firefox = isCompatible(browser, "Firefox", 41);
    console.log(browser);
    return chrome || firefox || opera || safari || ie;
}));

Handlebars.registerHelper('thirtyNine', toBlockHelper(function () {
    var browser = $.get_browser();
    return (browser.name === "Chrome" && browser.version <= "39");
}));

Handlebars.registerHelper('echo', function (str) {
    console.log(str);
    return str;
});

Handlebars.registerHelper('dateString', function (value, format) {
    if (!value) {
        return "";
    }
    const date = typeof value === "number" ? moment(value) : moment(value, "YYYY-MM-DD");

    return new Handlebars.SafeString(toDate(date, {format: format}));
});

//in each contacts' message history, we have an email preview mechanism, where we add the content of it, in an iframe
//in all cases, SRC must have something. In firefox, we need it to be  'src="javascript:"' so the content will be loaded
//in chromium browsers, this needs to be set 'src="about:blank"'
Handlebars.registerHelper('getIframeSrcForBrowser', function(options) {
    var browser = $.get_browser();
    if(browser.name === "Firefox")
        return new Handlebars.SafeString("javascript:");

    //toDo: needs to be checked in Safari and IE
    //if(browser.name === "Chrome" || browser.name === "Opera")
    return new Handlebars.SafeString("about:blank");
});

Handlebars.registerHelper('getCustomFieldAndInfo', function(cField, options) {
    if(cField == "date")
        return i18n.t("customFieldTypeDate");
    if(cField == "number")
        return i18n.t("customFieldTypeNumber");
    if(cField == "text")
        return i18n.t("customFieldTypeText");
    if(cField == "multipleChoice")
        return i18n.t("customFieldMultipleChoice")
    return cField;
});


function toDate(date, options) {
    date = moment.utc(date);

    var localeDate = date.local();
    var formatedDate;
    if (options.relative) {
        formatedDate = localeDate.fromNow();
    } else if (options.format) {
        formatedDate = localeDate.format(options.format);
    }

    return new Handlebars.SafeString(formatedDate);
}

Handlebars.registerHelper('userAction', actionType => actionType === "USER_ACCOUNT_LOGIN"
    ? i18n.t("appuseraction.login")
    : i18n.t("appuseraction.logout"));

Handlebars.registerHelper('importContactType', function (type) {
    const typeLowered = type.toLowerCase();
    switch (typeLowered) {
        case 'Gmail'.toLowerCase():
            return i18n.t('profile.importcontactreporttypegmail');
        case 'Yahoo'.toLowerCase():
            return i18n.t('profile.importcontactreporttypeyahoo');
        case 'Hotmail'.toLowerCase():
            return i18n.t('profile.importcontactreporttypehotmail');
        case 'File'.toLowerCase():
            return i18n.t('profile.importcontactreporttypefile');
        case 'ApiUploaded'.toLowerCase():
            return i18n.t('profile.importcontactreporttypeapi');
        default:
            return "";
    }
});

Handlebars.registerHelper('importContactStatus', function (status) {
    return status ? i18n.t('profile.importcontactreportstatusfinished') : i18n.t('profile.importcontactreportstatuspending');
});

Handlebars.registerHelper('importContactResults', function (succ, doubles, err, excee, dateFails, newContacts, valid) {
    return i18n.t('profile.importContactReportImportedContacts') + succ + ', ' +
        i18n.t('profile.importContactReportDuplicates') + doubles + ', ' +
        i18n.t('profile.importContactReportErroneous') + err + ', ' +
        i18n.t('profile.importContactReportExceeded') + excee + ', ' +
        i18n.t('profile.importContactReportInvalidDates') + dateFails + ', ' +
        i18n.t('profile.importContactReportNewContacts') + newContacts + ', ' +
        i18n.t('profile.importContactReportValid') + valid;
});

Handlebars.registerHelper('planTypeHelper', function (id) {
    switch (id) {
        case 1:
            return "Trial";
        case 2:
            return "Basic";
        case 3:
            return "Classic";
        case 4:
            return "Premium";
        case 5:
            return "Enterprise";
    }
});

//Sample usage: span {{t "my.key" }}
Handlebars.registerHelper('t', function (i18n_key, options) {
    var result;
    let count;
    if (options.hash.count) {
        count = parseInt(options.hash.count);
    } else if (options.hash.hasOwnProperty('count')) {
        count = 0;
    }
    if (options.hash) {
        options.hash.count = count;
        result = i18n.t(i18n_key, options.hash);
    } else {
        result = i18n.t(i18n_key);
    }

    return result;
});

//Sample usage: span {{t2 "my.k" "ey" }}
Handlebars.registerHelper('t2', function (i18n_key1, i18n_key2, options) {
    var i18n_key = i18n_key1 + i18n_key2;
    var result;
    if (options.hash.count) {
        result = i18n.t(i18n_key, {count: parseInt(options.hash.count)});
    } else if (options.hash.hasOwnProperty('count')) {
        result = i18n.t(i18n_key, {count: 0});
    } else {
        result = i18n.t(i18n_key);
    }

    return result;
});

Handlebars.registerHelper('osDetect', function () {
    return getMobileOperatingSystem();
});

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

//Sample usage:
//{{#tr this key="trans.sample.handlebarsExtended" add="from helper" }}
//Some Text
//<p>some paragraph with variable __add__ __addFromContext__</p>
//{{/tr}}
Handlebars.registerHelper('tr', function (context, options) {
    var opts = _.extend({}, options.hash, context);
    if (options.fn) opts.defaultValue = options.fn(context);

    return i18n.t(opts.key, opts);
});

//https://github.com/mazondo/gravatarjs
function gravatar(email, options) {
    //check to make sure you gave us something
    let opts = options || {},
        base,
        params = [];
    //set some defaults, just in case
    opts = {
        size: opts.size || "80",
        rating: opts.rating || "g",
        secure: opts.secure || (location.protocol === 'https:'),
        backup: opts.backup || ""
    };
    //setup the email address
    email = email.trim().toLowerCase();
    //determine which base to use
    base = opts.secure ? 'https://secure.gravatar.com/avatar/' : 'http://www.gravatar.com/avatar/';
    //add the params
    if (opts.rating) {
        params.push("r=" + opts.rating);
    }
    if (opts.backup) {
        params.push("d=" + encodeURIComponent(opts.backup));
    }
    if (opts.size) {
        params.push("s=" + opts.size);
    }
    //now throw it all together
    return base + md5(email) + "?" + params.join("&");
}

Handlebars.registerHelper('contacticon', function (s, options) {
    var settings = options.hash || {};
    var id;
    if (!settings.class) settings.class = "profileiconsmall";
    if (!settings.gravatarclass) settings.gravatarclass = "";
    if (s.subscriber.firstName || s.subscriber.lastName) {
        var colorClassId;
        if (s.subscriber.firstName || s.subscriber.lastName) {
            colorClassId = s.subscriber.firstName + s.subscriber.lastName;
            var n = (s.subscriber.lastName ? s.subscriber.lastName : "") + (s.subscriber.firstName ? s.subscriber.firstName : "");
            n = n.toLowerCase();
            id = n.substring(0, 1).normalize("NFD").substring(0, 1).toUpperCase();
            if (n.length > 1) {
                id += n.substring(1, 2).normalize("NFD").substring(0, 1);
            }
        } else { //msisdn
            colorClassId = s.msisdn;
            id = s.msisdn.substr(s.msisdn.length - 2, 2);
        }
        return new Handlebars.SafeString(`<div class='${settings.class} fg-black bgg-${Handlebars.helpers["tilecolorclass"](colorClassId)}'>${id}</div>`);
    } else if (s.username) {
        id = s.username.substring(0, 1).normalize("NFD").substring(0, 1).toUpperCase();
        id += s.username.substring(1, 2).normalize("NFD").substring(0, 1);

        return new Handlebars.SafeString(`<div class='usericonprofile fg-black bgg-${Handlebars.helpers["tilecolorclass"](s.username)}'>${id}</div>`);
    } else { //email
        var email = s.subscriber.email || s.msisdn;
        var imageSrc;
        if (settings.gravatar) {
            if (!settings.backup) settings.backup = 'identicon';
            imageSrc = gravatar(email || "", settings);
        } else {
            let options = {
                background: [255, 255, 255, 255],
                margin: 0,
                size: settings.size || 80
            };
            var data = new Identicon(Identicon.prototype.createHashFromString(email), options).toString();
            imageSrc = 'data:image/png;base64,' + data;
        }
        return new Handlebars.SafeString(`<div class='${settings.class}' title='${i18n.t('contacts.' + settings.class)}'><img src='${imageSrc}' class='${settings.gravatarclass}'/></div>`);
    }
});

Handlebars.registerHelper('concat', (...args) => _.initial(args).reduce((acc, x) => acc.concat(x)));

Handlebars.registerHelper('getIconForCountryCode', function (countryCode) {
    if (!countryCode)
        return new Handlebars.SafeString(`<span class='icon-warning fg-darkRed warnDist'></span>`);
    else if (countryCode === "001")
        return new Handlebars.SafeString(`<span class='icon icon-satellite'></span>`);
    else
        return new Handlebars.SafeString(`<span class='flag-icon flag-icon-${countryCode.toLowerCase()}'></span>`);
});

Handlebars.registerHelper('countryflagclass', function (phonenum) {
    phonenum = phonenum || "";
    /*Due to the i18n library works only with "+" and not the "00"
             if the user defines a number with "00" we remove them and we append the sign "+"
             */
    if (phonenum.indexOf("00") === 0) {
        phonenum = "+" + phonenum.substring(2);
    }
    if (phonenum.length) {
        try {
            const parsedPhoneNum = callingcode.parseAndKeepRawInput(phonenum);
            const countrycode = callingcode.getRegionCodeForNumber(parsedPhoneNum);
            const numberType = callingcode.getNumberType(parsedPhoneNum, countrycode);
            if (countrycode && (numberType === 1 || numberType === 2))
                return new Handlebars.SafeString(
                    `<i id='countryFlag' class='flag-icon flag-icon-${countrycode.toLowerCase()}'></i>` +
                    `<span id='country-code'> ${countrycode} </span>`);
        } catch (e) {
            console.info(`Unable to get region code for number: ${phonenum}`, e);
        }
        return new Handlebars.SafeString("<i id='countryFlag' class='icon-warning fg-darkRed'></i><span id='country-code'></span>");
    } else {
        return new Handlebars.SafeString("<i id='countryFlag'></i><span id='country-code'></span>");
    }

});
Handlebars.registerHelper('breakIfNecessary', (currentIndex, breakLine) =>
    new Handlebars.SafeString(currentIndex % breakLine === 0 ? "<tr></tr>" : ""));

Handlebars.registerHelper('countryflag', function (phonenum) {
    phonenum = phonenum || "";
    if (phonenum.indexOf("00") === 0) {
        phonenum = "+" + phonenum.substring(2);
    }
    if (phonenum.length) {
        try {
            const parsedPhoneNum = callingcode.parseAndKeepRawInput(phonenum);
            var countrycode = callingcode.getRegionCodeForNumber(parsedPhoneNum);
            var numberType = callingcode.getNumberType(parsedPhoneNum, countrycode);
            if (countrycode && (numberType === 1 || numberType === 2)) {
                //c toLowerCase because our sprite works with lowerCase letters while the library with Uppercase
                return new Handlebars.SafeString(
                    `<span id='countryFlag' class='flag-icon flag-icon-${countrycode.toLowerCase()}'></span>` +
                    `<span id='country-code'> ${countrycode} </span>`);
            }
        } catch (e) {
            console.log(e);
        }
        return new Handlebars.SafeString("<i class='icon-warning fg-darkRed'></i><span></span>");
    } else {
        return new Handlebars.SafeString("<i></i><span></span>");
    }

});


Handlebars.registerHelper('contactphoneflagclass', function (phonenum) {
    phonenum = phonenum || "";
    if (phonenum.length) {
        if (phonenum.indexOf("00") === 0) {
            phonenum = "+" + phonenum.substring(2);
        }

        var countrycode;
        try {
            const parsedPhoneNum = callingcode.parseAndKeepRawInput(phonenum);
            countrycode = callingcode.getRegionCodeForNumber(parsedPhoneNum);
            if (callingcode.isValidNumber(parsedPhoneNum, countrycode))
                return new Handlebars.SafeString(
                    `<span id='countryFlag' class='flag-icon flag-icon-${countrycode.toLowerCase()}'>`
                    + `</span><span id='country-code'> ${countrycode} </span>`);
        } catch (e) {
            console.info(`Unable to get region code for number: ${phonenum} ${e}`);
        }
        return new Handlebars.SafeString("<i id='countryFlag' class='icon-warning fg-darkRed'></i><span id='country-code'></span>");
    } else {
        return new Handlebars.SafeString("<i id='countryFlag'></i><span id='country-code'></span>");
    }

});

Handlebars.registerHelper('not', function (val) {
    return !val;
});

Handlebars.registerHelper('isOver12AndSingle', function (mcQuestion) {
    return mcQuestion.type === "SurveyMultipleChoice" && !mcQuestion.multiple && mcQuestion.choices.length > 12;
});

Handlebars.registerHelper('isOver12AndSingleCF', function (mcQuestion) {
    return mcQuestion.type === "CustomFieldMultipleChoiceComponent" && mcQuestion.choices.length > 12;
});

Handlebars.registerHelper('countryCodeToFlag', function (countrycode) {
    if (countrycode) {
        return (`flag-icon flag-icon-${countrycode.toLowerCase()}`);
    }
});

Handlebars.registerHelper('equals', toBlockHelper((v1, v2) => v1 === v2));

Handlebars.registerHelper('calculateAmount', (v1, v2) => new Handlebars.SafeString(`${v1 * v2}&#8364;`));

Handlebars.registerHelper('isPayPalButton', toBlockHelper(v1 => v1.type === "PayPalButton"));

Handlebars.registerHelper('notNullOrEmpty', toBlockHelper(v1 => v1 != null && v1 !== ''));


Handlebars.registerHelper('or', toBlockHelper((v1, v2, v3) => (v1 === v2) || (v1 === v3)));

Handlebars.registerHelper('aAndNotB', toBlockHelper((v1, v2, v3, v4) => (v1 === v2) && (v3 !== v4)));

Handlebars.registerHelper('notequals', toBlockHelper((v1, v2) => v1 !== v2));

Handlebars.registerHelper('gt', toBlockHelper((v1, v2) => v1 > v2));
Handlebars.registerHelper('gte', toBlockHelper((v1, v2) => v1 >= v2));
Handlebars.registerHelper('lt', toBlockHelper((v1, v2) => v1 < v2));
Handlebars.registerHelper('lte', toBlockHelper((v1, v2) => v1 <= v2));

Handlebars.registerHelper('formatBytesSize', function (pBytes, pUnits) {
    // Handle some special cases

    if (pBytes === 0) return '0 Bytes';
    if (pBytes === 1) return '1 Byte';
    if (pBytes === -1) return '-1 Byte';

    var bytes = Math.abs(pBytes);
    const {abbreviations, orderOfMagnitude} = Optional.ofNullable(pUnits)
        .map(u => u.toLowerCase())
        .filter(equals("si"))
        .map(() => ({
            // SI units use the Metric representation based on 10^3 as a order of magnitude
            orderOfMagnitude: Math.pow(10, 3),
            abbreviations: ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        })).orElseGet(() => ({
            // IEC units use 2^10 as an order of magnitude
            orderOfMagnitude: Math.pow(2, 10),
            abbreviations: ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        }));

    const i = Math.floor(Math.log(bytes) / Math.log(orderOfMagnitude));
    const result = (bytes / Math.pow(orderOfMagnitude, i)) * (pBytes < 0 ? -1 : 1);

    // This bit here is purely for show. it drops the precision on numbers greater than 100 before the units.
    // it also always shows the full number of bytes if bytes is the unit.
    return result >= 99.995 || i === 0 ? `${result.toFixed(0)} ${abbreviations[i]}` : `${result.toFixed(1)} ${abbreviations[i]}`;
});

const defined = v => Optional.ofNullable(v).map(v => v !== false).orElse(false);

Handlebars.registerHelper('ifeither', toBlockHelper((v1, v2) => defined(v1) || defined(v2)));

Handlebars.registerHelper('ifboth', toBlockHelper((v1, v2) => defined(v1) && defined(v2)));

/**
 * @Deprecated  this helper should be removed. Such operations should be done in the view.
 * This helper is used to return true when at least two of the given arguments are true (or have values), and false otherwise.
 */
Handlebars.registerHelper('ifCombination', toBlockHelper((...args) => args.filter(v => v).length > 2));

Handlebars.registerHelper('ifany', function () {
    /*  e.g. {{#ifany upgradeTypeBasic.length upgradeTypeClassic.length upgradeTypePremium.length '>' 0}}
        **  last argument = valueToCheck (0)
        **  argument before last = method ('>')
        **  all other = array ([upgradeTypeBasic, upgradeTypeClassic, upgradeTypePremium])
        **  arguments[arguments.length - 1] = options
        */
    const stringRepresentation = val => (!val || isNaN(val)) ? `"${val}"` : `${val}`;
    const [method, valueToCheck, opt] = _.last(arguments, 3);
    const repVal = stringRepresentation(valueToCheck);
    const array = _.initial(arguments, 3);
    const operators = [">", "<", "==", "===", "<=", ">=", "!==", "!="];
    if (operators.includes(method) &&
        array.map(stringRepresentation)
            .map(variable => eval(`${variable} ${method} ${repVal}`) === true)
            .reduce((acc, v) => acc || v))
        return opt.fn(this);

    return opt.inverse(this);
});

Handlebars.registerHelper('includedGroupsCountWithoutPseudoOnes', includedGroupsArray => _.filter(includedGroupsArray,
    group => !["q:in namedayToday()", "q:in birthdayToday()"].includes(group)).length);


Handlebars.registerHelper('sized', (n, {len}) => `${n}`.length <= Optional.ofNullable(len).orElse(3)
    ? `${n}`
    : new Handlebars.SafeString(($("<small/>").text(`${n}`))[0].outerHTML));

Handlebars.registerHelper('javaDateFormat', (withTime) => new Handlebars.SafeString(i18n.defaultDateFormatJava() + (withTime ? " HH:mm" : "")));

Handlebars.registerHelper('javaDateFormatDefault', () => new Handlebars.SafeString(i18n.defaultDateFormatJava()));

Handlebars.registerHelper('contactsReportName', function (contact) {
    contact.firstname = jsInjectionCleaner(contact.firstName);
    contact.lastname = jsInjectionCleaner(contact.lastName);
    contact.email = jsInjectionCleaner(contact.email);
    contact.msisdn = jsInjectionCleaner(contact.msisdn);

    const getOptionalAttr = attr => Optional.ofNullable(attr).filter(n => n !== "");

    const optionalFName = getOptionalAttr(contact.firstName);
    const optionalLName = getOptionalAttr(contact.lastName);
    return optionalFName.isPresent() || optionalLName.isPresent()
        ? (`${optionalFName.orElse("")} ${optionalLName.orElse("")}`)
        : getOptionalAttr(contact.email).orElse(contact.msisdn);

});

Handlebars.registerHelper('messageDeliveryStatus', function (status) {
    if (status === null) {
        return "";
    } else if (status === "DELIVERED") {
        return new Handlebars.SafeString("<span class='changepadding4to2' title='" + jsInjectionCleaner(i18n.t("message.smsdelivered")) + "'><i class='fg-emerald icon-rocket'></i></span>");
    } else if (status === "RETRY") {
        return new Handlebars.SafeString("<span class='changepadding4to2' title='" + jsInjectionCleaner(i18n.t("message.smspend")) + "'><i class='fg-orange icon-rocket'></i></span>");
    } else if (["NEW", "SENT"].includes(status)) {
        return new Handlebars.SafeString("<span class='changepadding4to2'  title='" + jsInjectionCleaner(i18n.t("message.smssent")) + "'><i class='fg-orange icon-rocket'></i></span>");
    } else {
        return new Handlebars.SafeString("<span class='changepadding4to2'  title='" + jsInjectionCleaner(i18n.t("message.smsfailed")) + "'><i class='fg-darkRed icon-rocket'></i></span>");
    }
});

const uurlStatus = function (status, icon, orangeCaption, greenCaption) {
    const getStatusSpan = (key, color, icon) =>
        `<span class='changepadding4to2' title='${i18n.t(key)}'><i class='${color} ${icon}'></i></span>`;
    if (status === null) {
        return "";
    } else if (!status) {
        return new Handlebars.SafeString(getStatusSpan(orangeCaption, 'fg-orange', icon));
    } else {
        return new Handlebars.SafeString(getStatusSpan(greenCaption, 'fg-green', icon));
    }
};

Handlebars.registerHelper('voucherStatus', status =>
    uurlStatus(status, 'icon-tellody-voucher', 'voucher.vouchernotredeemed', 'voucher.voucherredeemed'));

Handlebars.registerHelper('dlStatus', status =>
    uurlStatus(status, 'icon-tellody-content', "content.notdownloaded", "content.downloaded"));

Handlebars.registerHelper('urlStatus', status =>
    uurlStatus(status, 'icon-link', "content.linknotviewed", "content.linkviewed"));

Handlebars.registerHelper('optoutStatus', status =>
    uurlStatus(status, "icon-blocked", "message.contactnotoptedout", "message.contactoptedout"));

Handlebars.registerHelper('surveyStatus', status =>
    uurlStatus(status, 'icon-mic', "survey.notfilledinsurvey", "survey.filledinsurvey"));

const containsUURLHelper = (message, uurl) => Optional.ofNullable(message)
    .filter(m => m.includes(uurl))
    .isPresent();

Handlebars.registerHelper('containsOptout', toBlockHelper(_.partial(containsUURLHelper, _, '{UURL.optout}')));

Handlebars.registerHelper('containsUrl', toBlockHelper(message => containsUURLHelper(message, '{UURL.url}') || containsUURLHelper(message, '{UURL.urlcode}')));

Handlebars.registerHelper('containsContent', toBlockHelper(_.partial(containsUURLHelper, _, '{UURL.download}')));

Handlebars.registerHelper('containsVoucher', toBlockHelper(message => containsUURLHelper(message, '{UURL.voucher}') || containsUURLHelper(message, '{UURL.vouchercode}') || containsUURLHelper(message, '{woo.coupon}') || containsUURLHelper(message, '{woo.couponcode}')));

Handlebars.registerHelper('containsSurvey', toBlockHelper(_.partial(containsUURLHelper, _, '{UURL.survey}')));

Handlebars.registerHelper('dynamicFontSize', (value, length) =>
    value.toString().length > length ? new Handlebars.SafeString("font-smaller") : new Handlebars.SafeString(""));

Handlebars.registerHelper('thumbnail', function (url) {
    try {
        let url = new URL(url);
        if (url.hostname === 'www.youtube.com' && url.pathname === "/watch") {
            //Follows code adapted from: https://github.com/alrusdi/jquery-plugin-query-object/blob/master/jquery.query-object.js
            const s = url.search
                .replace(/^[?#]/, '') // remove any leading ? || #
                .replace(/[;&]$/, ''); // remove any trailing & || ;
            var dict = {};
            _.chain(s.split(/[&;]/))
                .map(el => el.split('=').map(decodeURIComponent))
                .filter(([key]) => key)
                .object()
                .value();
            if (dict.v) {
                //Info retrieved from: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
                return `http://i1.ytimg.com/vi/${dict.v}/0.jpg`;
            }
        }
    } catch (e) {
        //do nothing but fall back to the default
    }
    const encodedQuery = encodeURIComponent(url);
    return Math.random() < 0.5
        ? `https://api.thumbnail.ws/api/abb4600dce637c652e9ad6315b6143855c64e9889796/thumbnail/get?width=400&url=${encodedQuery}`
        : `https://api.thumbalizr.com/?api_key=9GO884ZVbRx0XSGPYfYFa1rtfIi&width=400&quality=10&url=${encodedQuery}`;
});
Handlebars.registerHelper('getLocationHref', function () {
    const url = location.href;
    const opts = _.last(arguments);
    return _.chain(arguments).initial().some(c => url.includes(c)).value()
        ? opts.fn(this)
        : opts.inverse(this);
});

/** @Deprecated
 * Should be removed, by handling this in the view
 * TODO
 */
Handlebars.registerHelper('checkForExecutingBulkCampaign', function (attrs) {
    return attrs.awaitsForMessagesToBeSent && attrs.campaignTemplateType === "BULK" && attrs.description === "";
});

Handlebars.registerHelper('isNotEmptyGroup', toBlockHelper((size, blockedCount, groupType) => groupType === "query" || size > (blockedCount || 0)));

Handlebars.registerHelper('isNotEmptyGroupBounced', toBlockHelper((size, bouncedCount, groupType) => groupType === "query" || size > (bouncedCount || 0)));

Handlebars.registerHelper('validStringOrDash', aString => aString && aString.trim().length > 0 ? aString : "-");

Handlebars.registerHelper('getPercentageAndFixedBy', function (number, digits) {
    if (Number.isNaN(number)) return "-";
    return (100 * number).toFixed(digits) + "%";
});

Handlebars.registerHelper('partOfTotalToPercentage', function (part, total) {
    if (!total) {
        return "-";
    }

    var valueToReturn = (100 * part / total).toFixed(2);
    if (valueToReturn.endsWith(".00")) {
        return valueToReturn.substr(0, valueToReturn.length - 3) + "%";
    } else {
        return valueToReturn + "%";
    }
});

Handlebars.registerHelper('classesForRating', function (number) {
    return number > 0.66
        ? "fak fa-smile-o  fg-emerald"
        : number > 0.33
            ? "fak fa-meh-o fg-orange"
            : "fak fa-frown-o fg-crimson";
});

Handlebars.registerHelper('cacheIndex', function (index) {
    this.index = index;
});

Handlebars.registerHelper('getAndCacheColor', function (id) {
    this.color = Handlebars.helpers["tilecolorclass"](id);
    return new Handlebars.SafeString(this.color);
});

Handlebars.registerHelper('getItemOfArray', (array, index, cycle) =>
    (array instanceof Array) ? array[cycle === true ? index % array.length : index] : array[index]);

Handlebars.registerHelper('extend', (obj1, obj2) => _.extend(obj1, obj2));

Handlebars.registerHelper('alias', (obj, name) => ({[name]: obj}));

Handlebars.registerHelper('withArrayElement', (array, index, options) => options.fn(array[index]));

Handlebars.registerHelper('getChoiceOfQuestionOfArray', (choiceIndex, array, questionIndex) =>
    Optional.ofNullable(array[questionIndex])
        .map(q => q.get('choices'))
        .map(c => c[choiceIndex])
        .map(jsInjectionCleaner)
        .orElse(""));

Handlebars.registerHelper('ifEven', toBlockHelper(number => number % 2 === 0));

Handlebars.registerHelper('smsSent', toBlockHelper(includedIn(["NEW", "SENT", "RETRY"])));

Handlebars.registerHelper('splitByVerticalLine', (str, index) => (jsInjectionCleaner(str).split("|")[index]));

Handlebars.registerHelper('ifNotColor', toBlockHelper(str => !/#[0-9a-fA-F]{3,6}/.test(str)));

Handlebars.registerHelper('ifCustomImage', toBlockHelper(str => /^[0-9a-fA-F]{24}$/.test(str)));

Handlebars.registerHelper('if', toBlockHelper(_.identity));

const getIconByServiceTypeAndDescription = function (type, description) {
    if (type === "survey" || type === "TELLODY_SURVEY") {
        switch (description) {
            case "Invit":
                return "icon-coffee";
            case "CustFeed":
                return "icon-comments-5";
            case "EventFeed":
                return "icon-thermometer";
            case "EmergAn":
                return "fak fa-bullhorn";
            case "CustSat":
                return "icon-star-2";
            case "BrandLoyalty":
                return "icon-power";
            default:
                return "icon-mic";
        }
    } else if (type === "voucher" || type === "TELLODY_VOUCHER") {
        switch (description) {
            case "giftCard":
                return "icon-gift";
            case "coupon":
                return "icon-discout";
            case "storeCard":
                return "icon-diamond";
            case "membershipCard":
                return "icon-medal";
            case "eventAdmission":
                return "fak fa-sign-in";
            case "identificationCard":
                return "fak fa-id-badge";
            case "showTicket":
                return "icon-playlist";
            case "seasonTicket":
                return "fak fa-calendar";
            case "points":
                return "fak fa-birthday-cake";
            default:
                return "icon-tellody-voucher";
        }
    } else if (type === "optin" || type === "EMAIL_OPTIN") {
        switch (description) {
            case "EventReg":
                return "fak fa-calendar-check-o";
            default:
                return "icon-enter";
        }
    } else if (type === "quiz" || type === "QUIZ_OPTIN") {
        return "icon-help-2";
    } else if (type === "instantWin" || type === "INSTANT_WIN") {
        switch (description) {
            case "sweepstakes":
                return "icon-gift";
            default:
                return "icon-trophy";
        }
    } else if (type === "payment" || type === "PayPalpayment" || type === "PAY_PAL_PAYMENT" ||
        type === "payPalPayment") {
        return "icon-dollar";
    } else if (type === "BULK") {
        switch (description) {
            case "SMS":
                return "icon-tellody-sms";
            case "EMAIL":
                return "icon-tellody-message";
            case "birthday" :
                return "icon-gift";
            default :
                return "icon-gift";
        }
    } else if (type === "daysLeft") {
        return "icon-clock";
    } else if (type === "creditsAvailable") {
        // description here is the double creditsAvailable
        if (description === 0)
            return "icon-lightning-3 fg-red";
        else if (description < 150)
            return "icon-cloudy fg-orange";
    } else if (type === "SMART_NOTIFICATION") {
        switch (description) {
            case "SMS_EVENT" :
                return "icon-tellody-sms";
            default:
                return "icon-tellody-message";
        }
    } else if (type === "contactImport")
        return "icon-tellody-user";
};

Handlebars.registerHelper('getStatusAndIconFor', function (type, model, status) {
    var fgColor = status === "ACTIVE" ? "fg-emerald" : (status === "ENDED" ? "fg-darkRed" : "fg-orange");
    var serviceTypeIcon = getIconByServiceTypeAndDescription(type, model.get("description"));
    var serviceIcon = "<i class='" + serviceTypeIcon + " " + fgColor + "'></i>";
    var appropriateCreationDateText = model.get("startDate") ? toDate(new Date(model.get("startDate")), {format: "L HH:mm"}) : i18n.t("now");

    var createdOnColor = location.href.indexOf("Message") > -1 ? "fg-white" : "fg-funkyOrange";
    var creationDate = "<span class='" + createdOnColor + "'>" + i18n.t("dashboard.createdOn") + ":</span> " + appropriateCreationDateText;

    var statusText = status === "NOT_STARTED" ? i18n.t("dashboard.scheduledMessage")
        : i18n.t((type !== "payment" ? type : "PayPal" + type) + (status === "ACTIVE" ? ".notdraft" : (status === "ENDED" ? ".ended" : ".draft")));
    var serviceStatus = "<h3 class='" + fgColor + " nbm'>" + jsInjectionCleaner(statusText) + "</h3>";

    var appropriateEndingText = status === "ENDED" ? i18n.t("voucher.endedOn") : i18n.t("subscriber.ending");
    var endDate = model.get("endDate") ? toDate(new Date(model.get("endDate")), {format: "L HH:mm"}) : i18n.t("never");

    serviceStatus += ($("<h5 style='font-weight:300; color:white; margin-top:0px; margin-bottom:0px; padding-bottom:2%;'></h5>").text(appropriateEndingText + ": " + endDate))[0].outerHTML;

    return new Object({htmlIcon: serviceIcon, htmlText: serviceStatus, htmlCreation: creationDate});
});

function getTitleBySvcTypeAndDescr(type, description) {
    if (type === "survey" || type === "TELLODY_SURVEY") {
        switch (description) {
            case "Invit":
                return "notification.invitation";
            case "CustFeed":
                return "notification.customerFeedback";
            case "EventFeed":
                return "notification.eventFeedback";
            case "EmergAn":
                return "notification.emergencyAnnouncement";
            case "CustSat":
                return "notification.customerSatisfaction";
            case "BrandLoyalty":
                return "notification.brandLoyalty";
            default:
                return "notification.survey";
        }
    } else if (type === "voucher" || type === "TELLODY_VOUCHER") {
        switch (description) {
            case "giftCard":
                return "notification.giftCard";
            case "coupon":
                return "notification.coupon";
            case "storeCard":
                return "notification.storeCard";
            case "membershipCard":
                return "notification.membershipCard";
            case "eventAdmission":
                return "notification.eventAdmission";
            case "identificationCard":
                return "notification.identificationCard";
            case "showTicket":
                return "notification.showTicket";
            case "seasonTicket":
                return "notification.seasonTicket";
            default:
                return "notification.voucher";
        }
    } else if (type === "optin" || type === "EMAIL_OPTIN" || type === "QUIZ_OPTIN") {
        switch (description) {
            case "EventReg":
                return "notification.eventRegistration";
            default:
                return "notification.optin";
        }
    } else if (type === "instantWin" || type === "INSTANT_WIN") {
        switch (description) {
            case "sweepstakes":
                return "notification.sweepstakes";
            default:
                return "notification.instantWin";
        }
    } else if (type === "payment" || type === "PayPalpayment" || type === "PAY_PAL_PAYMENT") {
        return "notification.payPalPayment";
    } else if (type === "SMART_NOTIFICATION") {
        switch (description) {
            case "EMAIL_EVENT" :
                return "notification.emailEvent";
            default :
                return "notification.smsEvent";
        }
    }
}

Handlebars.registerHelper('getNotificationIcon', function (type, description) {
    if (type === "SMART_NOTIFICATION") {
        return `<i class="${getIconByServiceTypeAndDescription(type, description)} smallicon"></i><i class="icon-lightning"></i>`;
    } else if (description === "birthday" || description === "nameday") {
        return `<i class="${getIconByServiceTypeAndDescription("BULK", type)} smallicon"></i><i class="icon-gift"></i>`;
    } else if (type === "daysLeft") {
        return '<i class="icon-shipping smallicon"></i><i class="icon-clock"></i>';
    } else if (type === "emailAvailable") {
        return '<i class="icon-shipping smallicon"></i><i class="icon-tellody-message"></i>';
    } else {
        return `<i class="${getIconByServiceTypeAndDescription(type, description)}"></i>`;
    }
});
const bgByServiceType = {
    voucher: "ribbed",
    survey: "bbgg",
    url: "bg",
    file: "bg"
};
Handlebars.registerHelper('getBgClassForService', type => bgByServiceType[type]);

Handlebars.registerHelper('getIconClassViaTypeAndDescription', (type, description) => getIconByServiceTypeAndDescription(type, description));

Handlebars.registerHelper('getIconViaTitleStatusAndDescription', function (type, title, status, description) {
    var icon = getIconByServiceTypeAndDescription(type, description);
    var color = status === "ACTIVE" ? "fg-emerald" : status === "ENDED" ? "fg-darkRed" : "fg-orange";

    var typePrefix = type === "voucher" ? "voucher" : description === "sweepstakes" ? "sweepstakes" : "survey";

    let t;
    switch (status) {
        case "ACTIVE":
            t = i18n.t(`${type}.${typePrefix}active`);
            break;
        case "ENDED":
            t = i18n.t(`${type}.${typePrefix}ended`);
            break;
        default:
            t = i18n.t(`${type}.${typePrefix}scheduled`);
    }

    return `<i class="${icon} ${color}" title="${t}"></i>`;
});

Handlebars.registerHelper('getIconForNetwork', function (network) {
    let icon = '';
    switch (network.toUpperCase()) {
        case "FACEBOOK":
            icon = 'icon-facebook';
            break;
        case "TWITTER":
            icon = 'icon-twitter';
            break;
        case "GPLUS":
            icon = 'icon-google-plus';
            break;
    }
    return icon;
});

Handlebars.registerHelper('getVoucherNameByDescription', description => description !== null && $.trim(description).length > 0 ? i18n.t("voucher." + description) : i18n.t("voucher.nameofvoucher"));

Handlebars.registerHelper('notEmptyCampaignTitle', toBlockHelper(str => (str.split("|")[0] !== "")));

Handlebars.registerHelper('datePH', function () {
    var ldf = i18n.t("$dateformat");
    // $dateformat value change to be compatible with moment so don't need it change
    // for (var i = 0; i < ldf.length; i++) {
    //     if (ldf.charAt(i).match(/[a-z]/i)) {
    //         ldf = ldf.slice(0, i) + ldf.charAt(i) + ldf.slice(i, ldf.length);
    //         i++;
    //     }
    // }
    return ldf;
});

Handlebars.registerHelper('getNameOrEmailOrPhone', function (subscription) {
    const optionalSubscription = Optional.ofNullable(subscription);
    const subscriber = optionalSubscription.flatMap(sn => Optional.ofNullable(sn.subscriber));
    const lastName = subscriber.flatMap(s => Optional.ofNullable(s.lastName)).map(jsInjectionCleaner);
    const firstName = subscriber.flatMap(s => Optional.ofNullable(s.firstName)).map(jsInjectionCleaner);
    const email = subscriber.flatMap(s => Optional.ofNullable(s.email)).map(jsInjectionCleaner);
    const msisdn = optionalSubscription.flatMap(s => Optional.ofNullable(s.msisdn)).map(jsInjectionCleaner);

    return lastName.map(lName => `${lName} ${firstName.orElse("")}`)
        .or(() => firstName)
        .or(() => email)
        .or(() => msisdn)
        .orElse(i18n.t("survey.anonymousresponder"));
});

/**
 * A function that produces the content for a service usage notification bubble.
 *
 * @param model The model of the service usage notification bubble.
 * @returns The string to be entered as content of the service usage notification bubble.
 *          The string starts with an article that depends on the language of the user.
 *          Continues with a blue colored part of the subscribers available info, separated with comma if
 *          they are two.
 *          Continues with a supplementary count of the remaining users that used the service on this
 *          bubble time frame.
 *          And ends with a dictionary entry of the type of usage based on the type of the service
 *          (i.e voucher, survey, etc.) followed by the title of the service emphasized in blue.
 */
function subscribersInfoConstructor(model) {
    return Optional.ofNullable(model).flatMap(x => {
        return Optional.ofNullable(x.subscribersInfo).map(y => {
            // This reduce function is used to make an object returned by the server
            // with the format of {1: {...}, 2: {...}}
            // to array of the inner objects [{...}, {...}].
            // todo refactor the subscribersInfo structure returned by the server.
            const subscribersInfo = _.reduce(y, (accumulator, object) => accumulator.concat(object), []);
            const stringToReturn = [];
            stringToReturn.push(i18n.t("arthro", {count: subscribersInfo.length}));
            let count = model.redeemers - subscribersInfo.length;
            stringToReturn.push(" <span style='color: #6dcff6;'>");
            stringToReturn.push(subscriberInfoIterFun("", $.extend(true, [], subscribersInfo))); // Deep copy because
            // we use the length of subscribersInfo again below.
            stringToReturn.push("</span>");
            if (!stringToReturn.join("").includes(",") && count !== 0) {
                // Meaning if there is only one subscriber info and the number of redeemers is
                // greater than zero, we have the use case that the same subscriber has
                // used the service multiple times in this notification bubble's time frame,
                // so we do not need to ad the "and n more contacts" part.
                count = 0;
            }
            if (count > 0)
                stringToReturn.push(" ", i18n.t("andNMoreContacts", {count: count}));
            stringToReturn.push(" ", (model.campaignTemplateType === "TELLODY_SURVEY" ?
                i18n.t("submitted", {count: subscribersInfo.length}) :
                i18n.t("used", {count: subscribersInfo.length})));
            stringToReturn.push(" ", i18n.t(getTitleBySvcTypeAndDescr(model.campaignTemplateType,
                model.templateSubType)), " ");
            stringToReturn.push(($("<span style='color: #6dcff6;'></span>").text(model.title))[0].outerHTML);
            return stringToReturn.join("");
        }); // If the subscribersInfo is null or undefined return an empty string.
        // Something went wrong! Service Usage Notification Bubble without users ?!
    }).orElse(""); // If the model is null or undefined return an empty string.
                   // Something went wrong!
}

/**
 * A function to return a string that contains subscribers info for at most two users of the service usage
 * notification. (Comma separated)
 *
 * @param toReturn The string to append upon on every recursion.
 * @param subscribers The subscribers <br>arrray</br> to recurse upon.
 * @returns The string of subscribers info.
 */
function subscriberInfoIterFun(toReturn, subscribers) {
    // Max 3 iterations with the termination condition.
    if (subscribers.length === 0) {
        return toReturn;
    } else if (subscribers.length === 1) {
        // Add comma if a subscriber info is assigned to string from previous iteration.
        const addCommaIfNeeded = toReturn ? toReturn + ", " : "";
        const subscriber = subscribers.splice(0, 1)[0]; // Nullable, but not throwing error.
        return subscriberInfoIterFun(addCommaIfNeeded + getSubscriberInfo(subscriber), subscribers);
    } else {
        const subscriber = subscribers.splice(0, 1)[0]; // Nullable, but not throwing error.
        return subscriberInfoIterFun(toReturn + getSubscriberInfo(subscriber), subscribers);
    }
}

/**
 * A function to return a string with info about a user participating on a service usage notification
 * bubble.
 *
 * @param iteratee The subscriber info object to extract a representing string for him according to
 *               any not null properties.
 * @returns The subscriber info string. If N/A or "Άγνωστος/η" appears something went wrong.
 */
function getSubscriberInfo(iteratee) {
    // Maybe here is handmade by Stefanos Papadogiannis type
    // It is a proof of concept. A more concrete code for the same functionality
    // is at the end of the function and uses optional-js.
    return Maybe(iteratee).bind(i => {
        const msisdnMaybe = Maybe(i.msisdn).bind(m => {
            return m;
        }).maybe(i18n.t("notAvailable"), value => {
            return value;
        });
        const emailMaybe = Maybe(i.email).bind(e => {
            return e;
        }).maybe(msisdnMaybe, value => {
            return value;
        });
        const firstName = Maybe(i.firstName).bind(fN => {
            return fN;
        }).maybe(emailMaybe, value => {
            return value;
        });
        return Maybe(i.lastName).bind(lN => {
            return Maybe(i.firstName).bind(fN => {
                return lN + " " + fN;
            }).maybe(lN, value => {
                return value;
            });
        }).maybe(firstName, value => {
            return value;
        });
    }).maybe(i18n.t("notAvailable"), value => {
        return value;
    });

    // Stays here for understanding the above code.
    // return Optional.ofNullable(iteratee).map(x => {
    //     return x.lastName ? (x.firstName ? (x.lastName + " " + x.firstName) : x.lastName) :
    //                             (x.firstName ? x.firstName :
    //                                     (x.email ? x.email :
    //                                         (x.msisdn ? x.msisdn : "")));
    // }).orElse("");
}

Handlebars.registerHelper('getTitleOrDefaultTextForSurvey', (title, type) => Optional.ofNullable(title).filter(t => t !== "").orElse(i18n.t(`survey.noname${type}`)));

Handlebars.registerHelper('getTitleOrDefaultTextForPayPalPayment', title => Optional.ofNullable(title).filter(t => t !== "").orElse(i18n.t("survey.nonamePayPalPayment")));

Handlebars.registerHelper('getTitleOrDefaultTextForInstantWin', title => Optional.ofNullable(title).filter(t => t !== "").orElse(i18n.t("instantWin.instantWinText")));

Handlebars.registerHelper('getTitleOrDefaultTextForQuiz', title => Optional.ofNullable(title).filter(t => t !== "").orElse(i18n.t("survey.nonamequizOptin")));

Handlebars.registerHelper('getTitleOrDefaultTextForSweepstakes', title => Optional.ofNullable(title).filter(t => t !== "").orElse(i18n.t("instantWin.sweepstakesTitle")));

Handlebars.registerHelper('getTitleOrDefaultTextForOptin', title => Optional.ofNullable(title).filter(t => t !== "").orElse(i18n.t("optin.noTitle")));

Handlebars.registerHelper('getTitleOrDefaultTextForVoucher', title => Optional.ofNullable(title).filter(t => t !== "").orElse(i18n.t("voucher.nonameservice")));

Handlebars.registerHelper('isDraftScheduled', toBlockHelper((campaignId, status) => campaignId === 0 || status === "NOT_STARTED"));

Handlebars.registerHelper('isNotDraftScheduled', toBlockHelper((campaignId, status) => campaignId > 0 && status !== "NOT_STARTED"));

Handlebars.registerHelper('isScheduled', toBlockHelper((campaignId, status) => campaignId > 0 && status === "NOT_STARTED"));

Handlebars.registerHelper('isServiceActive', toBlockHelper((campaignId, status) => campaignId > 0 && status === "ACTIVE"));

Handlebars.registerHelper('isNaN', toBlockHelper(isNaN));

Handlebars.registerHelper('getLang', () => i18n.language);

//add the prefix "trigger-" on Voucher/Survey Tiles, on message report, if they are used as triggering events
Handlebars.registerHelper('prefixToAdd', attr => isNaN(attr) ? new Handlebars.SafeString("trigger-") : new Handlebars.SafeString(""));

Handlebars.registerHelper('isServiceSelected',
    toBlockHelper(({
                       usedFor,
                       selectedVoucher,
                       triggeredCampaignId,
                       selectedSurvey,
                       selectedOptin,
                       selectedInstantWin,
                       selectedPayPalPayment,
                       campaignId
                   }) => usedFor === "trigger"
        ? [selectedVoucher, selectedSurvey, selectedOptin, selectedInstantWin, selectedPayPalPayment].includes(triggeredCampaignId)
        : selectedVoucher === campaignId || selectedSurvey === campaignId));

Handlebars.registerHelper('getAnswersInCorrectOrderAccordingToQuestions', function (questions, currentAnswers) {

    const questionTypesArray = $.map(questions, question => question.get('kind'));
    const payPalComponent = _.filter(questions, question => question.get("type") === "PayPalButton");
    const hasPayPal = payPalComponent != null && payPalComponent.length > 0;
    currentAnswers.txt = currentAnswers.txn ? jsInjectionCleaner(currentAnswers.txn) : null;
    const txn = currentAnswers.txn ? currentAnswers.txn : "-";
    const txnTag = `<td>${txn}</td>`;
    let contentToReturn = hasPayPal ? (txnTag) : "";

    _.each(questionTypesArray, function (questionType) {
        const $contactLink = $(`<a href='/CampaignCloud/cloudui/home/Contacts.htm#${currentAnswers.subscriptionId}' class='fg-hover-orange'></a>`);
        switch (questionType) {
            case "mobile": {
                const mobile = ($contactLink.text(currentAnswers.msisdn ? currentAnswers.msisdn : "-"))[0].outerHTML;
                contentToReturn += `<td>${mobile}</td>`;
            }
                break;
            case "email": {
                const email = ($contactLink.text(currentAnswers.email ? currentAnswers.email : "-"))[0].outerHTML;
                contentToReturn += `<td>${email}</td>`;
            }
                break;
            case "birthday": {
                const birthday = (currentAnswers.dateOfBirth ? Handlebars.helpers["timestamp"](currentAnswers.dateOfBirth, "L") : "-");
                contentToReturn += `<td>${birthday}</td>`;
            }
                break;
            case "firstname":
                contentToReturn += ($("<td/>").text(currentAnswers.firstName ? currentAnswers.firstName : "-"))[0].outerHTML;
                break;
            case "lastname":
                contentToReturn += ($("<td/>").text(currentAnswers.lastName ? currentAnswers.lastName : "-"))[0].outerHTML;
                break;
            case "profession":
                contentToReturn += ($("<td/>").text(currentAnswers.profession ? currentAnswers.profession : "-"))[0].outerHTML;
                break;
            case "address":
                contentToReturn += ($("<td/>").text(currentAnswers.address))[0].outerHTML;
                break;
            default:
                if (questionType.includes("cf")) {
                    const cf = currentAnswers.customFieldsMap && currentAnswers.customFieldsMap[questionType] ?
                        (
                            typeof currentAnswers.customFieldsMap[questionType] === "string" && currentAnswers.customFieldsMap[questionType].includes("datetime") ?
                                moment(currentAnswers.customFieldsMap[questionType].split("datetime:")[1], "x").format(i18n.t("optinMomentDateTimeFormat")) :
                                currentAnswers.customFieldsMap[questionType]
                        ) : "-";
                    contentToReturn += `<td>${cf}</td>`;
                }
                break;
        }
    });
    return new Handlebars.SafeString(contentToReturn);
});

Handlebars.registerHelper('getPlaceholderFor', function (kind) {
    switch (kind) {
        case "mobile":
            return i18n.t("optin.mobilePlaceholder");
        case "email":
            return i18n.t("optin.emailPlaceholder");
        case "firstname":
            return i18n.t("optin.firstnamePlaceholder");
        case "lastname":
            return i18n.t("optin.lastnamePlaceholder");
        case "address":
            return i18n.t("optin.addressPlaceholder");
        case "profession":
            return i18n.t("optin.professionPlaceholder");
        default:
            return i18n.t("survey.youranswer");
    }
});

Handlebars.registerHelper('toFixed', function (number, digits) {
    return Optional.ofNullable(number).map(n => n.toFixed(digits)).orElse("");
});

/* TODO REMOVE!!!!!!!!!! */
Handlebars.registerHelper('objectWithProperty', function (obj) {
    return $.extend({"reportPage": true}, obj);
});

Handlebars.registerHelper('timestampWithMonthText', timestamp => timestamp === undefined
    ? ""
    : timestamp === null
        ? jsInjectionCleaner(i18n.t("now"))
        : (`${moment(timestamp).locale(moment.tz.guess()).format("DD MMM YYYY H:mm")} (${moment.tz.guess()})`));

Handlebars.registerHelper('getVoucherTypeByDescription', description =>
    ["showTicket", "eventAdmission", "identificationCard"].indexOf(description) > -1 ? "eventTicket" : "coupon");

Handlebars.registerHelper('parseNewLineCharacters', rawText => rawText.replace(/\\n/g, "\n"));

Handlebars.registerHelper('arrayIsEmpty', arrayToCheck => arrayToCheck == null ? true : arrayToCheck.length === 0);

Handlebars.registerHelper('getEmailTemplatesCategories', function (layouts) {
    var categories = ['message.coffeeBarRestaurantCat', 'message.beautyFashionCat', 'message.wellnessHotelCat',
        'message.celebrationHolidayCat', 'message.notificationCat', 'message.newsletterCat', 'message.eCommerceCat'];

    var contentToReturn = '<li><a class="emailThemeFilter bg-white fg-funkyOrange bg-hover-grayLight fg-hover-white" data-value="">' + i18n.t('reports.allbutton') + ' (' + layouts.length + ')</a></li>';
    $.each(categories, function (index, category) {
        var themesInCategory = $.grep(layouts, function (layout) {
            return layout.tags.indexOf(i18n.t(category)) > -1;
        }).length;

        contentToReturn += '<li><a class="emailThemeFilter bg-white fg-funkyOrange bg-hover-grayLight fg-hover-white" data-value="' + i18n.t(category) + '">' + i18n.t(category) + ' (' + themesInCategory + ')</a></li>';
    });

    return contentToReturn;
});

Handlebars.registerHelper('print', str => {
    console.info(str);
});

Handlebars.registerHelper('includes', toBlockHelper((str, substr) => str.includes(substr)));

Handlebars.registerHelper('extractTrigger', expression=>expression.split("\\")[0]);

Handlebars.registerHelper('getAppropriateGroupTitle', function ({groupType, query, subscriptionType, deletable}) {

    if (groupType === "query" && query === 'in satisfactionMetricBetween(0, 0.35)' && deletable === false)
        return i18n.t('groups.lowSatisfactionTitle');
    else if (groupType === "query" && query === 'in satisfactionMetricBetween(0.35, 0.66)' && deletable === false)
        return i18n.t('groups.mediumSatisfactionTitle');
    else if (groupType === "query" && query === 'in satisfactionMetricBetween(0.66, 1)' && deletable === false)
        return i18n.t('groups.highSatisfactionTitle');
    else if (groupType === "enum" && subscriptionType === 'EMAIL')
        return i18n.t('groups.bouncedEmailsTitle');
    else if (groupType === 'enum')
        return i18n.t('fileup.group');
    else
        return i18n.t('groups.querygroup');
});

Handlebars.registerHelper('getNotificationMessage', model => model.jsonClass === "ServiceUsage"
    ? subscribersInfoConstructor(model)
    : model.jsonClass !== "DaysLeft"
        ? model.jsonClass !== "EmailAvailable"
            ? model.jsonClass !== "CreditsAvailable"
                ? model.jsonClass !== "ContactImport"
                    ? campaignTypeName(model) + " " + ($(' <span style="color : #6dcff6;"></span> ').text(model.title))[0].outerHTML + " " + getNotificationSecondPart(model)
                    : i18n.t("contactImport", {count: model.count})
                : model.creditsAvailable === 0
                    ? i18n.t("dashboard.credits-depleted")
                    : i18n.t("dashboard.credits-low")
            : i18n.t("emailAvailable", {count: model.emailAvailable})
        : i18n.t("daysLeft", {count: model.daysLeft}));


Handlebars.registerHelper('beatifyNumber', function (number, options) {
    if(!number)
        return "";

    var beautifiedNumber = "";
    var stringifiedNumber = number.toString();

    var splitter = i18n.language == "el" ? "." : ",";

    if(stringifiedNumber.length <= 3 )
        return number;

    for(var i = stringifiedNumber.length - 3; i >= 0; i-=3) {

        if(beautifiedNumber != "") {
            var indexTo = i + 3 <= stringifiedNumber.length ? i+3 : stringifiedNumber.length;
            var threeDigits = stringifiedNumber.substring(i, indexTo);

            beautifiedNumber = threeDigits + splitter + beautifiedNumber;

        }
        else {
            var threeDigits = stringifiedNumber.substring(i);
            beautifiedNumber = threeDigits;
        }
    }

    // check if the last iteration "missed" the last characters, due to them being less than four in count
    /*
        i.e. we have the number 100.000 (one hundred thousands)
        The last iteration, will not take into account the 100 in the beginning,
        due to it having less than four characters
    */

    var hasLessThanThreeCharacters = stringifiedNumber.length%3 != 0;

    if(hasLessThanThreeCharacters) {
        var lastDigits = stringifiedNumber.substring(0, stringifiedNumber.length % 3);
        beautifiedNumber = lastDigits + splitter + beautifiedNumber;
    }

    return beautifiedNumber;
});

function campaignTypeName(model) {

    const {sms, emails, templateSubType, campaignTemplateType} = model;
    if (emails != null) {
        if (campaignTemplateType === "SMART_NOTIFICATION") {
            return i18n.t("notificationEmailEvent");
        } else if (templateSubType === 'birthday') {
            return i18n.t("notificationBirthdayTitle");
        } else if (templateSubType === 'nameday') {
            return i18n.t("notificationNameDayTitle");
        } else {
            return i18n.t("notificationBulkTitle");
        }
    }
    if (sms != null) {
        if (campaignTemplateType === "SMART_NOTIFICATION") {
            return i18n.t("notificationSmsEvent");
        } else if (templateSubType === 'birthday') {
            return i18n.t("notificationBirthdayTitle");
        } else if (templateSubType === 'nameday') {
            return i18n.t("notificationNameDayTitle");
        } else {
            return i18n.t("notificationBulkTitle");
        }
    }
    // todo switch case
    if (campaignTemplateType === "BULK") {
        return i18n.t("notificationBulkTitle");
    }
    switch (campaignTemplateType) {
        case "TELLODY_SURVEY":
            switch (templateSubType) {
                case "Invit":
                    return i18n.t("notificationInvitationTitle");
                case "CustFeed":
                    return i18n.t("notificationCustomerFeedbackTitle");
                case "CustSat":
                    return i18n.t("notificationCustomerSatisfactionTitle");
                case "EventFeed":
                    return i18n.t("notificationEventFeedbackTitle");
                case "EmergAn":
                    return i18n.t("notificationEmergencyAnnouncementTitle");
                case "BrandLoyalty":
                    return i18n.t("notificationBrandLoyaltyTitle");
                case "":
                    return i18n.t("notificationSurveyTitle");
            }
            break;
        case "TELLODY_VOUCHER":
            switch (templateSubType) {
                case "giftCard":
                    return i18n.t("notificationGiftCardTitle");
                case "coupon":
                    return i18n.t("notificationCouponTitle");
                case "storeCard":
                    return i18n.t("notificationStoreCardTitle");
                case "membershipCard":
                    return i18n.t("notificationMembershipTitle");
                case "eventAdmission":
                    return i18n.t("notificationEventAdmissionTitle");
                case "identificationCard":
                    return i18n.t("notificationIdentificationCardTitle");
                case "showTicket":
                    return i18n.t("notificationShowTicketTitle");
                case "seasonTicket":
                    return i18n.t("notificationSeasonTicketTitle");
                case "":
                    return i18n.t("notificationVoucherTitle");
            }
            break;
        case "EMAIL_OPTIN": //todo
            if (templateSubType === "EventReg") {
                return i18n.t("notificationEventRegistrationTitle");
            } else if (templateSubType === "OptIn") {
                return i18n.t("notificationOptinTitle");
            }
            break;
        case "PAY_PAL_PAYMENT":
            return i18n.t("notificationPayPalPaymentTitle");
        case "QUIZ_OPTIN":
            return i18n.t("notificationquizTitle");
        case "INSTANT_WIN":
            if (templateSubType === "sweepstakes") {
                return i18n.t("notificationSweepstakesTitle");
            } else if (templateSubType === "instantWin") {
                return i18n.t("notificationInstantWinTitle");
            }
            break;
        case "SMART_NOTIFICATION":
            if (templateSubType === "EMAIL_EVENT") {
                return i18n.t("notificationEmailEvent");
            } else if (templateSubType === "SMS_EVENT") {
                return i18n.t("notificationSmsEvent");
            }
            break;
        case "nameday":
            return i18n.t("notificationNameDayTitle");
        case "birthday":
            return i18n.t("notificationBirthdayTitle");
    }
    return "";
}

function getNotificationSecondPart(model) {

    const {campaignTemplateType, totalRecipients, jsonClass, emails, sms} = model;

    switch (jsonClass) {
        case "CampaignStartNotification": // todo check
            return i18n.t("notificationCampaignStarted");
        case "CampaignEndNotification":
            return i18n.t("notificationCampaignEnded") + totalParticipants(campaignTemplateType, totalRecipients);
        case "EmailNotification":
            return i18n.t("notificationEmailSent", {emails});
        case "SmsNotification":
            return i18n.t("notificationSmsSent", {sms});
    }
}

function totalParticipants(campaignTemplateType, count) {

    const recCnt = {count};
    if (campaignTemplateType === "EMAIL_OPTIN")
        return i18n.t("contactsOptedIn", recCnt);
    else if (["QUIZ_OPTIN", "INSTANT_WIN", "PAY_PAL_PAYMENT"].includes(campaignTemplateType))
        return i18n.t("participants", recCnt);
    else if (["TELLODY_SURVEY", "TELLODY_VOUCHER"].includes(campaignTemplateType))
        return i18n.t("users", recCnt);
    else if (["SMART_NOTIFICATION", "nameday", "birthday"].includes(campaignTemplateType))
        return i18n.t("recipientsByTrigger", recCnt);
    else
        return "";
}